import { Row } from "ant-design-vue";
const { ...other } = Row;

const YwRow = {
	...other,
	name: "YwRow",
};

YwRow.install = function (Vue) {
	Vue.component(YwRow.name, Row);
};

export default YwRow;
